export const modelStatusColor = {
"1":"rgb(255 188 71)",
"0":"rgb(71 181 255)",
"2":"rgb(255 71 71)"
}